import { Controller } from "@hotwired/stimulus"

// Opens the Ask AI chat (courses/ai_chats/_launcher). On the answered screen the chat
// takes the card's place from sm up and is a bottom sheet on phones; on the results
// page every question's button points the one modal's frame at its own chat (a bottom
// sheet on phones too). A sheet or modal locks the page scroll and closes on Escape.
export default class extends Controller {
    static targets = ["panel", "frame", "trigger"]
    static values = { modal: Boolean }

    open({ currentTarget, params: { src } }) {
        if (!this.hasPanelTarget || !this.hasFrameTarget) return

        this.opener = currentTarget
        if (this.frameTarget.getAttribute("src") !== src) this.frameTarget.src = src
        this.panelTarget.classList.remove("hidden")
        this.overlay = this.modalValue || !window.matchMedia("(min-width: 640px)").matches
        if (this.overlay) {
            document.body.classList.add("overflow-hidden")
        } else {
            this.triggerTargets.forEach((trigger) => trigger.classList.add("hidden"))
            this.reveal()
            // The chat is taller than its loading state: bring it into view again once in.
            if (!this.frameTarget.complete) {
                this.frameTarget.addEventListener("turbo:frame-load", () => this.reveal(), { once: true })
            }
        }
    }

    reveal() {
        this.panelTarget.scrollIntoView({ behavior: "smooth", block: "nearest" })
    }

    close() {
        if (!this.hasPanelTarget || this.panelTarget.classList.contains("hidden")) return

        this.panelTarget.classList.add("hidden")
        this.triggerTargets.forEach((trigger) => trigger.classList.remove("hidden"))
        if (this.overlay) document.body.classList.remove("overflow-hidden")
        this.opener?.focus({ preventScroll: true })
    }

    closeOnEscape(event) {
        if (event.key === "Escape" && this.overlay && !document.querySelector("#report-mistake-modal:not(.hidden)")) this.close()
    }

    disconnect() {
        if (this.overlay && this.hasPanelTarget && !this.panelTarget.classList.contains("hidden")) {
            document.body.classList.remove("overflow-hidden")
        }
    }
}
